import script from "./pressDetailPage.vue?vue&type=script&setup=true&lang=js"
export * from "./pressDetailPage.vue?vue&type=script&setup=true&lang=js"

import "./pressDetailPage.vue?vue&type=style&index=0&id=e0bee7da&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e0bee7da"]])

export default __exports__